import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { MONTHS } from '../../utilities/birthdays'
import {
  addDays, currentMonth, isFutureMonth, monthRange, shiftMonth, validatePeriod, yearOptions,
} from '../../utilities/dashboard'

// Filtros da aba Prontuário, numa linha acima de tudo: Doutor (TODOS) e Período (‹ mês ano ›, ou Personalizar com de/até).
// O ano do período é o ano base do mês a mês. Meses futuros não podem ser escolhidos. Sem type='month' (Firefox e Safari)
const DashboardFilters = ({ tecnicoOptions, tecnicoId, onTecnicoChange, period, today, firstYear, periodText, onPeriodChange }) => {
  const [custom, setCustom] = useState(() => !period.month)
  const [customStart, setCustomStart] = useState(period.start_date)
  const [customEnd, setCustomEnd] = useState(period.end_date)
  const [customError, setCustomError] = useState('')

  // No modo mês, o mês do período; num período personalizado, o mês da data final (cortada em hoje)
  const selected = period.month || currentMonth((period.end_date < today) ? period.end_date : today)
  const now = currentMonth(today)
  const years = yearOptions(firstYear, today, selected.year)
  const atFirst = (selected.year === years[0]) && (selected.month === 1)
  const atCurrent = (selected.year > now.year) || ((selected.year === now.year) && (selected.month >= now.month))

  const selectMonth = (value) => onPeriodChange(monthRange(shiftMonth(value, 0, today)))

  function openCustom() {
    setCustomStart(period.start_date)
    setCustomEnd((period.end_date > today) ? today : period.end_date)
    setCustomError('')
    setCustom(true)
  }

  function applyCustom() {
    const error = validatePeriod(customStart, customEnd, today)
    if (error) return setCustomError(error.message)
    setCustomError('')
    onPeriodChange({ start_date: customStart, end_date: customEnd })
  }

  function backToMonth() {
    setCustom(false)
    setCustomError('')
    if (!period.month) selectMonth(selected)
  }

  return (
    <div className='dashboard-filters' role='group' aria-label='Filtros da aba Prontuário'>
      <Form.Group className='dashboard-filter'>
        <Form.Label htmlFor='dashboard-tecnico'>Doutor</Form.Label>
        <Form.Select id='dashboard-tecnico' size='sm' value={tecnicoId} onChange={(e) => onTecnicoChange(e.target.value)}>
          <option value=''>TODOS</option>
          {tecnicoOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
        </Form.Select>
      </Form.Group>

      <div className='dashboard-filter'>
        <span className='form-label' id='dashboard-period-label'>Período</span>
        {!custom ?
          <div className='dashboard-period' role='group' aria-labelledby='dashboard-period-label'>
            <Button variant='outline-secondary' size='sm' aria-label='Mês anterior' disabled={atFirst} onClick={() => selectMonth(shiftMonth(selected, -1, today))}>‹</Button>
            <Form.Select size='sm' aria-label='Mês' value={selected.month} onChange={(e) => selectMonth({ year: selected.year, month: Number(e.target.value) })}>
              {MONTHS.map((month) => (
                <option key={month.value} value={month.value} disabled={isFutureMonth({ year: selected.year, month: month.value }, today)}>{month.full}</option>
              ))}
            </Form.Select>
            <Form.Select size='sm' aria-label='Ano (também é o ano base do mês a mês)' value={selected.year} onChange={(e) => selectMonth({ year: Number(e.target.value), month: selected.month })}>
              {years.map((year) => <option key={year} value={year}>{year}</option>)}
            </Form.Select>
            <Button variant='outline-secondary' size='sm' aria-label='Próximo mês' disabled={atCurrent} onClick={() => selectMonth(shiftMonth(selected, 1, today))}>›</Button>
            <Button variant='link' size='sm' className='dashboard-link-button' onClick={openCustom}>Personalizar</Button>
          </div>
          :
          <div className='dashboard-period' role='group' aria-labelledby='dashboard-period-label'>
            <Form.Control
              type='date'
              size='sm'
              aria-label='Início do período'
              value={customStart}
              max={today}
              onChange={(e) => setCustomStart(e.target.value)}
            />
            <span className='dashboard-period-sep'>a</span>
            <Form.Control
              type='date'
              size='sm'
              aria-label='Fim do período'
              value={customEnd}
              min={customStart || undefined}
              max={customStart ? addDays(customStart, 365) : undefined}
              onChange={(e) => setCustomEnd(e.target.value)}
            />
            <Button variant='primary' size='sm' onClick={applyCustom}>Aplicar</Button>
            <Button variant='link' size='sm' className='dashboard-link-button' onClick={backToMonth}>Escolher mês</Button>
          </div>
        }
        {customError ? <small className='dashboard-filter-error' role='alert'>{customError}</small> : ''}
      </div>

      <span className='dashboard-period-text' aria-live='polite'>{periodText}</span>
    </div>
  )
}

export default DashboardFilters
